/**
 * Adding more than this many net words to a transcript entry (vs. its loaded
 * text) forces the user to re-select that entry's time range before saving —
 * large wording changes usually mean the timing drifted.
 */
export const MAX_WORD_CHANGE = 5;

/** Frame-step increments (seconds) for nudging the playhead while placing markers. */
export const FRAME_STEP_SMALL = 1 / 30; // ~one frame at 30fps
export const FRAME_STEP_LARGE = 0.5;

/**
 * When reassigning an entry to a neighbor's speaker, the two only auto-merge if
 * their timestamps are within this many seconds of each other (a negative gap —
 * a true overlap — always qualifies). Larger gaps stay as separate entries.
 */
export const MERGE_MAX_GAP_SECONDS = 2;

/**
 * Below this (0–1) speaker-label confidence, a sentence is flagged in the editor
 * for the reviewer to verify/reassign. Legacy sentences without the field are
 * never flagged.
 */
export const SPEAKER_CONFIDENCE_THRESHOLD = 0.5;

/**
 * Minimum word count for a sentence to be offered as a speaker-identification
 * sample in the quick-assign prompt. Short lines ("Yeah.", "Okay") rarely help
 * a reviewer recognize a voice, so they're skipped.
 */
export const MIN_SAMPLE_WORDS = 5;
